import { render } from "./FileTable.vue?vue&type=template&id=53dac9d5"
import script from "./FileTable.vue?vue&type=script&lang=js"
export * from "./FileTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__